import HttpUtil from '@/common/HttpUtil'

const userInfo = {
  //更改用户信息
  changeUserinfo(param) {
    let url = process.env.VUE_APP_DOMAIN + '/auth';
    return HttpUtil.patch(url,param)
  },

  //获取用户绑定的学会申请表
  getApplication(params) {
    let url = process.env.VUE_APP_DOMAIN + '/getMemberByUserid';
    return HttpUtil.get(url,params)
  },
  //获取用户信息
  getUserinfo(){
    let url = process.env.VUE_APP_DOMAIN + '/getUserinfo';
    return HttpUtil.get(url, null)
  },
  //撤销会员申请
  repealApplication(params){
    let url = process.env.VUE_APP_DOMAIN + '/backoutMember';
    return HttpUtil.get(url, params)
  },
  // 获取修改手机号验证码
  saveMobileByCode(params){
    let url = process.env.VUE_APP_DOMAIN + '/saveMobileByCode';
    return HttpUtil.post(url, params)
  }

};
export default userInfo
